module.exports = __webpack_public_path__ + "img/trophy_0001_toolbox.faa91df4.png";